import {insertImage} from '@/utils/editor-scripts';
import {CurrentPageStore} from '@/store/content-optimizer/currentPage';
import {useEffect} from 'react';
import styles from '../../style.module.scss';


interface Props {
  onChange: (editorState: any) => any;
  store: CurrentPageStore;
  contentType: string;
}

export const Unsplash = ({onChange, store, contentType}: Props) => {
  const UNSPLASH_ACCESS_KEY = '420741e2ab2cac6791ea245e6c504e359bd3b5b7ced07e96d9e08babe9e1fa6d';
  const {updateHeroImage} = store;

  let UnsplashReact = null;
  let namedExports = null;
  if (typeof window === 'object') {
    UnsplashReact = require('unsplash-react').default;
    namedExports = require('unsplash-react');
    // { Base64Uploader, withDefaultProps } = namedExports;
  }


  useEffect(() => {
    const searchInput = document.querySelectorAll('.f-1');
    if ( searchInput[0]) {
      (searchInput[0] as HTMLInputElement).placeholder= `Try "dog" or "apple"`;
    }
    // setTimeout(() => {
    //   const imageGrid = document.querySelectorAll('.unsplash-react__image-grid');
    //   if (imageGrid[0]) {
    //     const labels = imageGrid[0].querySelectorAll('.d-f');
    //     labels.forEach(label => {
    //       (label as HTMLElement).style.display = 'none';
    //     })
    //   }
    // }, 1000)
  }, []);

  const onAddImage = imageUrl => {
    if (contentType == 'asHero') {
      updateHeroImage(imageUrl, '');
    } else {
      onImageUpload(imageUrl);
    }
  };

  const onImageUpload = imageUrl => {
    const newEditorState = insertImage(store.currentEditorState, imageUrl);
    onChange(newEditorState);
  };


  return ( <div className={styles.unsplashContainer}>
    {UNSPLASH_ACCESS_KEY ? <UnsplashReact
      accessKey={UNSPLASH_ACCESS_KEY}
      Uploader={namedExports.withDefaultProps(namedExports.InsertIntoApplicationUploader)}
      onFinishedUploading={imageUrl => onAddImage(imageUrl)}
    /> : null}
  </div>

  );
};
